import { atom } from 'recoil';

export type ValidationField =
  | 'criteria'
  | 'customReason'
  | 'rescheduledDate'
  | 'snoozeDate'
  | 'snoozeNote';

export type ValidationError = {
  field: ValidationField;
  serviceId?: string;
  message: string;
};

export type FeedbackInputValidationType =
  | 'Failed'
  | 'Rescheduled'
  | 'Done'
  | 'Snooze';

export type ValidationState = Map<
  FeedbackInputValidationType,
  Array<ValidationError>
>;

const validationState = atom<ValidationState>({
  key: 'validationState',
  default: new Map(),
});

export default validationState;
